import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { UrlFilters } from '@elementary/common-ui/hooks/useUrlFilters';
import useSearchParams from '@elementary/common-ui/hooks/useSearchParams';
import { getTestResultsLink } from '../../utils';
import ContentWithLabel from '../shared/ContentWithLabel';

const ValueWrapper = styled(Flex)`
  gap: 8px;
  align-items: flex-end;
  margin-bottom: 20px;
`;

const Value = styled(Typography)`
  font-size: 40px;
  font-weight: 500;
  line-height: 44px;
  color: ${({ theme }) => theme.palette.common.gray2};
`;

type Props = {
  total: number;
  selectedFilters: UrlFilters | undefined;
};

const TotalTests = ({ total, selectedFilters }: Props) => {
  const [searchParams] = useSearchParams();

  return (
    <ContentWithLabel
      variant="big"
      title="Total Tests"
      link={getTestResultsLink(searchParams, selectedFilters)}
    >
      <ValueWrapper>
        <Value>{total}</Value>
      </ValueWrapper>
    </ContentWithLabel>
  );
};

export default TotalTests;
